// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-MdmTable-components-MdmTableSystemTools-MdmTableSystemTools-module__box--KCAgO {
  display: flex;
  align-items: center;
  gap: 8px;
}
/*# sourceMappingURL=MdmTableSystemTools.module.css.map */`, "",{"version":3,"sources":["webpack://./MdmTableSystemTools.module.less","webpack://./src/components/MdmTable/components/MdmTableSystemTools/MdmTableSystemTools.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;ACCF;AACA,yDAAyD","sourcesContent":[".box {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n",".box {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n/*# sourceMappingURL=MdmTableSystemTools.module.css.map */"],"sourceRoot":""}]);
// Exports
export var box = `src-components-MdmTable-components-MdmTableSystemTools-MdmTableSystemTools-module__box--KCAgO`;
export default ___CSS_LOADER_EXPORT___;
